﻿<script setup lang="ts">

    import { BulmaErrorClass, CodeEditSessionItem } from '@/shared/codeedit/codeEditSessionItem.ts';
    import { AttributeValue } from '@/shared/codeedit/codeEditFields.ts';

    type Props = {
        clearable?: boolean;
        field: string;
        label: string;
        state: CodeEditSessionItem;
        setFieldValue?: (_field: string, _value: AttributeValue) => void;
    };
    const props = withDefaults(defineProps<Props>(), {
        clearable: true,
        setFieldValue: (_field: string, _value: AttributeValue) => undefined
    });
</script>

<template>
    <b-field
        horizontal
        :type="BulmaErrorClass(props.state.validationErrors[props.field]?.type)"
        :message="props.state.validationErrors[props.field]?.message ?? ''"
        :label="props.label">
        <div class="is-flex is-justify-content-space-between is-gap-1">
            <div class="is-flex-grow-1">
                <slot />
            </div>
            <div class="is-flex-1">
                <slot name="unit" />
            </div>
            <b-tooltip
                v-if="props.clearable"
                class="control"
                label="Clear field"
                position="is-top">
                <b-button
                    class="control"
                    :disabled="props.state.modified[props.field] === null"
                    @click="props.setFieldValue(props.field, null)">
                    <b-icon
                        icon="eraser"
                        size="is-small" />
                </b-button>
            </b-tooltip>
        </div>
    </b-field>
</template>

<style scoped>

</style>
